import { Button, ButtonGroup, Modal, PrimaryButton } from "@nulogy/components";
import useAvailabilityOverridesUnsavedChangesModal from "hooks/state/useAvailabilityOverridesUnsavedChangesModal";
import React, { useRef } from "react";

export default function AvailabilityOverridesUnsavedChangesModal({ onClose }) {
  const { close: closeModal, isOpen, startDate, endDate } = useAvailabilityOverridesUnsavedChangesModal();
  const submitButton = useRef();

  const submit = () => {
    submitButton.current.click();
  };

  const close = () => {
    closeModal();
    onClose(startDate, endDate);
  };

  const footerContent = (
    <ButtonGroup>
      <PrimaryButton className="spec-save-changes-in-modal" onClick={submit}>
        Save and apply to schedule
      </PrimaryButton>
      <Button onClick={close}>Discard changes</Button>
    </ButtonGroup>
  );

  return (
    <>
      <input ref={submitButton} style={{ display: "none" }} type="submit" />
      <Modal
        ariaHideApp={false}
        footerContent={footerContent}
        isOpen={isOpen}
        onRequestClose={close}
        title="Unsaved changes"
      >
        Changes will be discarded if you navigate to a different date before saving.
      </Modal>
    </>
  );
}
